import SidebarContent from "./SidebarContent.jsx";

const ThreadsSidebar = ({
  year,
  threads,
  activeThreadId,
  handlePdfUpload,
  onNewThread,
  onSelectThread,
  onLoadMoreThreads,
  hasMoreThreads,
  handleStartCv,
  isGeneratingCv,
  handleGenerateCvPdf,
  handleCancelCv
}) => {
  return (
    <div className="jacai-sidebar d-none d-md-flex flex-column">
      <SidebarContent
        year={year}
        threads={threads}
        activeThreadId={activeThreadId}
        handlePdfUpload={handlePdfUpload}
        onNewThread={onNewThread}
        onSelectThread={onSelectThread}
        onLoadMoreThreads={onLoadMoreThreads}
        hasMoreThreads={hasMoreThreads}
        isMobile={false}
        handleStartCv={handleStartCv}
        isGeneratingCv={isGeneratingCv}
        handleGenerateCvPdf={handleGenerateCvPdf}
        handleCancelCv={handleCancelCv}
      />
    </div>
  );
};

export default ThreadsSidebar;